import React from "react";
// import CoursesImage1 from "../Assets/Slide3/Aboutimage.png";
import pdfimg from "../Assets/Examcell/PDFIMG.png";
import CoursesImage1 from "../Assets/Examcell/certificateIMG.png";
const Certificate = () => {
  return (
    <div className="w-full overflow-hidden p-5 m-4">
      <h1 className='text-center font-bold text-3xl text-[#228B22]'>Approvals </h1>
      <hr
        className="section-divider my-1 border-[#D3D3D3]  mx-auto pb-5"
        style={{ width: "10%" }}
      />
      {/* Full width main image */}
      <img
        src={CoursesImage1}
        alt="Full Width Display"
        className="w-full  object-cover mb-4 sm:w-full md:w-[95%] lg:w-full xl:w-full 2xl:w-full mb-[2%] rounded-[5px]"
      />
      {/* Grid for 4 images */}
      <div className="grid grid-cols-1  sm:grid-cols-4 gap-4 p-3 mb-[1%]">
         <a href="https://srijyothipolytechnic.com/certificates/EOAReport2025-26.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2025-26</h1>
              <p className="text-center text-sm">Extension of Approval for the Academic Year 2025-26.</p>
            </div></div>
        </a>
      <a href="https://srijyothipolytechnic.com/certificates/EOAReport2024-25.PDF">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2024-25</h1>
              <p className="text-center text-sm">Extension of Approval for the Academic Year 2024-25.</p>
            </div></div>
        </a>
      <a href="https://srijyothipolytechnic.com/certificates/EOAReport2023-24.PDF">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2023-24</h1>
              <p className="text-center text-sm">Extension of Approval for the Academic Year 2023-24.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2022-23</h1>
              <p className="text-center text-sm">Extension of Approval for the Academic Year 2022-23.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate1.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2021-22</h1>
              <p className="text-center text-sm">Extension of Approval for the Academic Year 2021-22.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate2.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2020-21</h1>
              <p className="text-center text-sm">Extension of Approval for the Academic Year 2020-21.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate3.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2019-20</h1>
              <p className="text-center text-sm">Extension of Approval for the Academic Year 2019-20.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate4.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2018-19</h1>
              <p className="text-center text-sm">Extension of Approval for the Academic Year 2018-19.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate5.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2017-18</h1>
              <p className="text-center text-sm">Extension of approval for the academic year 2017-18.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate6.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2016-17</h1>
              <p className="text-center text-sm">Extension of approval for the academic year 2016-17.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate7.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2015-16</h1>
              <p className="text-center text-sm">Extension of approval for the academic year 2015-16.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate8.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold">EOA Report 2014-15</h1>
              <p className="text-center text-sm">Extension of approval for the academic year 2014-15.</p>
            </div></div>
        </a>
        <a href="https://srijyothipolytechnic.com/certificates/certificate9.pdf">
          <div className="flex row bg-white rounded-xl shadow-lg  p-2">
            <img
              src={pdfimg}
              alt="Image 2"
              className="w-[30%]  object-cover "
            />
            <div className="pl-1 mt-4">
              <h1 className="text-center text-xl  font-bold mb-1">LOA report 2013-14</h1>
              <p className="text-center text-sm ">Approval for New Institute/  Change of site from Academic year 2013-2014.</p>
            </div></div>
        </a>
        
      </div>
    </div>
  );
};
export default Certificate;